(() => {
  class WbcTroughLanding extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.form = this.querySelector('[data-tt-form]');
      this.select = this.querySelector('[data-tt-variant]');
      this.radios = Array.from(this.querySelectorAll('[data-tt-size]'));
      this.selection = this.querySelector('[data-tt-selection]');
      this.submit = this.querySelector('[data-tt-submit]');
      this.dock = this.querySelector('[data-tt-dock]');
      this.dockButton = this.querySelector('[data-tt-dock-trigger]');
      if (!this.form || !this.select || !this.submit) return;
      this.radios.forEach((radio) => {
        radio.required = !radio.disabled;
        radio.addEventListener('change', () => {
          this.select.value = radio.value;
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        }, { signal });
      });
      this.select.addEventListener('change', () => this.sync(true), { signal });
      this.form.addEventListener('submit', (event) => {
        if (this.select.value) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.selection.textContent = this.dataset.sizeNeeded;
        this.focusSizes();
      }, { signal, capture: true });
      this.form.addEventListener('cart:error', () => {
        this.selection.textContent = this.select.selectedOptions[0]?.dataset.selection || this.dataset.sizeNeeded;
      }, { signal });
      this.select.required = false;
      this.sync(false);
      this.classList.add('is-enhanced');
      this.querySelector('[data-tt-guide]')?.addEventListener('click', () => {
        const panel = this.querySelector('[data-tt-guide-panel]');
        if (!panel) return;
        panel.open = true;
        panel.scrollIntoView({ block: 'start', behavior: 'instant' });
        panel.querySelector('summary')?.focus({ preventScroll: true });
      }, { signal });
      const photos = Array.from(this.querySelectorAll('[data-tt-photo]'));
      const viewButtons = Array.from(this.querySelectorAll('[data-tt-view]'));
      if (photos.length > 1) {
        const showPhoto = (view) => {
          photos.forEach((photo) => { photo.hidden = photo.dataset.ttPhoto !== view; });
          viewButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.ttView === view)));
        };
        viewButtons.forEach((button) => button.addEventListener('click', () => showPhoto(button.dataset.ttView), { signal }));
        showPhoto('back');
      }
      if (this.dock && this.dockButton && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.dock.classList.toggle('is-visible', !entry.isIntersecting);
        }, { threshold: 0.2 });
        this.observer.observe(this.submit);
        this.dockButton.addEventListener('click', () => {
          if (!this.select.value) {
            this.selection.textContent = this.dataset.sizeNeeded;
            this.focusSizes();
            return;
          }
          if (this.submit.disabled || this.submit.getAttribute('aria-busy') === 'true') return;
          this.form.requestSubmit(this.submit);
        }, { signal });
      }
      this.form.addEventListener('variant:add', () => {
        this.dataset.cartConfirmed = 'true';
      }, { signal });
    }
    sync(updateUrl) {
      const selected = this.select.selectedOptions[0];
      const hasSize = Boolean(selected?.value);
      this.radios.forEach((radio) => { radio.checked = radio.value === this.select.value; });
      this.selection.textContent = hasSize ? selected.dataset.selection : this.dataset.sizeNeeded;
      this.querySelectorAll('[data-tt-price]').forEach((price) => {
        if (hasSize) price.textContent = selected.dataset.price;
      });
      this.submit.disabled = this.dataset.productAvailable !== 'true' || (hasSize && selected.dataset.available !== 'true');
      if (this.dockButton) {
        this.dockButton.textContent = hasSize ? this.dataset.addLabel : this.dataset.chooseLabel;
        this.dockButton.disabled = this.submit.disabled;
      }
      if (updateUrl && hasSize) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        history.replaceState(history.state, '', url);
      }
      delete this.dataset.cartConfirmed;
    }
    focusSizes() {
      const first = this.radios.find((radio) => !radio.disabled);
      this.form.scrollIntoView({ block: 'center', behavior: 'instant' });
      first?.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  }
  if (!customElements.get('wbc-trough-landing')) customElements.define('wbc-trough-landing', WbcTroughLanding);
})();

